import React, { useContext } from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { FormikProps } from 'formik';
import { YesNoOptions, GetChildTypeOptions, MaritalStatuses } from '../../../../global/constants/lists';
import { FormField } from '../../../../global/components/form-element/form-field';
import { FormGroup } from '../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { YesNoIndicators } from '../../../../global/models/api-model';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { RelationshipsProps } from '../../models/account-info-epi-props';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { AccountInfoRoutes } from '../../constants/routes';
import { DependentTypes, DependentsState } from './dependents-model';
import { TcsmStates } from '../../../../root/tcsm-model';
import { DemographicsContext } from '../../../../global/models/demographics-model';

interface DependentFieldProps {
	formProps: FormikProps<any>;
	disabled: boolean;
	relationshipProps: RelationshipsProps;
}
export function DependentFields(props: DependentFieldProps) {
	const {
		formProps,
		disabled,
		relationshipProps,
	} = props;

	const history = useHistory();
	const app = useContext(DemographicsContext);
	const dependentsState = useSelector<TcsmStates, DependentsState>(state => state.dependents[app]);
	const childDeathLink = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${AccountInfoRoutes.RelationshipsSegment}${AccountInfoRoutes.DeathOfChild}`);
	const isMyCpg = history?.location?.pathname?.includes(AccountInfoRoutes.MyCpgRoot);
	const isMarried = useSelector<TcsmStates, boolean>(state => state.personalInfo[app]?.currentPerson?.marital_status === MaritalStatuses.Married);
	function ChildFields() {

		return (
			<>
				<ContentSpacer>
					<FormField
						name='child_type'
						label={relationshipProps?.childTypeLabel}
						component="radioGroup"
						options={GetChildTypeOptions(relationshipProps, isMarried && !disabled)}
						touched={formProps.touched}
						errors={formProps.errors}
						required
						disabled={disabled}
					/>
					<FormField
						name='disabled_child_indicator'
						label={relationshipProps?.disabledChildQuestionLabel}
						component="radioGroup"
						options={YesNoOptions}
						touched={formProps.touched}
						errors={formProps.errors}
						required
					/>
					{
						formProps?.values?.disabled_child_indicator === YesNoIndicators.Yes
						&&
						<ContentSpacer>
							<Banner
								banner={{
									type: 'warning',
									label: <WysiwygWithReactLink content={relationshipProps?.disabledChildWarningMessage} />,
								}}
							/>
						</ContentSpacer>
					}
				</ContentSpacer>
				{
					dependentsState?.dependents?.children?.length > 0 &&  isMyCpg && formProps?.values?.dependent_type === DependentTypes.child && (
						<ContentSpacer>
							<button className='link-button' type='button' onClick={() => history.push(childDeathLink)}>{relationshipProps?.reportDeceasedChild}</button>
						</ContentSpacer>
					) 
				}
			</>
		);
	}

	return (
		<FormGroup>
			<ChildFields />
		</FormGroup>
	);
}